const state = {
  hotelResult: {},
  hotelDetailsResult: {},
  hotelResults: {},
  searchResults: {},
  searchHistory: [],
  hotelSearchHistory: []
}

const mutations = {
  saveHotelResult (state, result) {
    state.hotelResult = result;
  },
  saveHotelDetailsResult (state, result) {
    state.hotelDetailsResult = result;
  },
  saveHotelResults (state, {key, result}) {
    state.hotelResults[key] = result;
  },
  saveSearchResult (state, {key, result}) {
    state.searchResults[key] = result;
  },
  saveSearchCriteria(context, params) {
    state.searchHistory.push(params);
  },
  saveHotelSearchCriteria(context, params) {
    state.hotelSearchHistory.push(params);
  }
}

const actions = {
  saveHotelResult (context, result) {
    context.commit('saveHotelResult', result);
  },
  saveHotelDetailsResult (context, result) {
    context.commit('saveHotelDetailsResult', result);
  },
  saveHotelResults (context, {key, result}) {
    context.commit('saveHotelResults', {key, result});
  },
  saveSearchResult (context, {key, result}) {
    context.commit('saveSearchResult', {key, result});
  },
  saveSearchCriteria (context, params) {
    context.commit('saveSearchCriteria', params);
  },
  saveHotelSearchCriteria (context, params) {
    context.commit('saveHotelSearchCriteria', params);
  }
}

const getters = {
  getHotelResult: state => {
    return state.hotelResult;
  },
  getHotelDetailsResult: state => {
    return state.hotelDetailsResult;
  },
  getHotelResults: state => key => {
    return state.hotelResults[key];
  },
  getSearchResults: state => key => {
    return state.searchResults[key];
  },
  getSearchHistory: state => state.searchHistory,
  getHotelSearchHistory: state => state.hotelSearchHistory
}

export default {
  state,
  mutations,
  getters,
  actions
}